import { useState } from 'react';
import api from '../../api/api';

const Risk = ({ isOpen, onClose,fetchdata,setSelectedTab, selectedCard, setToastMessage, setToastSeverity, setOpenToast }) => {
  const [selectedButton, setSelectedButton] = useState(null);
  const [loading, setLoading] = useState(false); // State to manage loading
  const practiseid = window.getPracticeId();

  const handleButtonClick = (buttonType) => {
    setSelectedButton(buttonType);
  };

  const handleSubmit = async () => {
    setLoading(true); // Set loading to true when the API call starts
    try {
      const response = await api.put(`/v1/${practiseid}/patient/${selectedCard?.patientid}/rpm/highrisk`, {
        "risksts": selectedButton,
      });
      if (response.status === 200) {
        setToastMessage(response.message);
        setToastSeverity('success');
        setOpenToast(true);
setSelectedButton('')
if(selectedButton===0){
  fetchdata({billnoteligible:"CNTB" })
  setSelectedTab(0)
}else if(selectedButton===1){
  fetchdata({highriskpat :"HIGHRISK" })
  setSelectedTab(2)
}else if(selectedButton===2){
  fetchdata({callbackpat :"CALLBACK"})
  setSelectedTab(3)
}else if(selectedButton===3){
  fetchdata({devicebackpat:"DEVICEBACK"})
  setSelectedTab(4)
}

        setTimeout(() => onClose(false), 2000);
      }
    } catch (error) {
      setToastMessage('Something went wrong');
      setToastSeverity('error');
      setOpenToast(true);
      console.error("Error submitting form:", error);
    } finally {
      setLoading(false); // Set loading to false after the API call finishes
    }
  };

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 h-auto overflow-scroll custom-scrollbar">
          <div className="bg-white rounded-lg shadow-lg w-full lg:max-w-[30%] max-w-[80%] mx-4 sm:mx-auto my-4">
            <div className="flex justify-between items-center border-b p-4 bg-[#E179544A]">
              <h2 className="text-xl font-semibold">Filter</h2>
              <button
                onClick={() => {
                    setSelectedButton('')
                  onClose(false);
                }}
                className="text-gray-500 hover:text-gray-700 text-3xl"
              >
                &times;
              </button>
            </div>

            <div className="p-4">
              {/* Buttons */}
              <div className="flex gap-4  flex-column">
                <button
                  onClick={() => handleButtonClick(0)}
                  className={`${
                    selectedButton === 0 ? 'bg-[#D97842] text-white' : 'bg-white border-[1.4px] border-gray-200 text-gray-600'
                  } text-sm px-6 py-[12px] rounded-full hover:bg-[#D97842]`}
                >
                  Normal
                </button>
                <button
                  onClick={() => handleButtonClick(1)}
                  className={`${
                    selectedButton === 1 ? 'bg-[#D97842] text-white' : 'bg-white border-[1.4px] border-gray-200 text-gray-600'
                  } text-sm px-6 py-[12px] rounded-full hover:bg-[#F97316]`}
                >
                  High Risk
                </button>
                <button
                  onClick={() => handleButtonClick(2)}
                  className={`${
                    selectedButton === 2 ? 'bg-[#D97842] text-white' : 'bg-white border-[1.4px] border-gray-200 text-gray-600'
                  } text-sm px-6 py-[12px] rounded-full hover:bg-[#F97316]`}
                >
                  CallBack
                </button>
                
                <button
                  onClick={() => handleButtonClick(3)}
                  className={`${
                    selectedButton === 3 ? 'bg-[#D97842] text-white' : 'bg-white border-[1.4px] border-gray-200 text-gray-600'
                  } text-sm px-6 py-[12px] rounded-full hover:bg-[#F97316]`}
                >
                  Device Recall
                </button>
              </div>

              {/* Submit Button */}
              <div className="flex justify-end mt-4">
                <button
                  onClick={handleSubmit}
                  disabled={loading || !selectedButton===''} // Disable the button if loading or no selection
                  className={`${
                    loading || !selectedButton==='' ? 'bg-blue-300 cursor-not-allowed' : 'bg-[#F97316] hover:bg-blue-600'
                  } text-white text-sm px-6 py-2 rounded-lg`}
                >
                  {loading ? 'Submitting...' : 'Submit'} {/* Change button text when loading */}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Risk;
